module.exports = __webpack_public_path__ + "img/ic_product.a4f8bddf.svg";